import React from "react";
import { Sun, Moon } from "lucide-react";
import { useTheme } from "../context/ThemeContext";

/**
 * ThemeToggle — pill button that flips between light & dark themes.
 * Variants:
 *   - "default" : light pill on light surfaces
 *   - "dark"    : translucent pill on dark / gradient surfaces (e.g. final navy CTA)
 */
export default function ThemeToggle({ variant = "default", className = "" }) {
  const { theme, toggle } = useTheme();
  const isDark = theme === "dark";

  const base = "inline-flex items-center gap-2 px-3 py-2 rounded-full text-xs font-semibold transition-all duration-300 hover:-translate-y-0.5";
  const styles = variant === "dark"
    ? "bg-white/10 border border-white/20 text-white hover:bg-white/20"
    : "bg-white border border-rule text-ink hover:border-signal hover:text-signal shadow-sm";

  return (
    <button
      onClick={toggle}
      aria-label={`Switch to ${isDark ? "light" : "dark"} mode`}
      title={`Switch to ${isDark ? "light" : "dark"} mode`}
      data-testid="theme-toggle"
      data-theme-state={theme}
      className={`${base} ${styles} ${className}`}
    >
      {isDark ? <Sun size={14} className="text-yellow-400" /> : <Moon size={14} />}
      <span className="hidden sm:inline">{isDark ? "Light" : "Dark"}</span>
    </button>
  );
}
